import { useCallback, useContext } from "react";
import { useDispatch } from "react-redux";
import { DomestikaContext } from "../../../DomestikaContext";

export const useDomainUseCase = () => {
  const domain = useContext(DomestikaContext);
  const dispatch = useDispatch();

  const execute = useCallback(
    ({ useCase, params, getLoadingAction, getErrorAction, getSuccessAction }) => {
      dispatch(getLoadingAction());
      /* eslint-disable-next-line no-underscore-dangle */
      domain
        ._getter(useCase)
        .execute(params)
        .then(([error, data]) => {
          if (error) {
            dispatch(getErrorAction(error));
          } else {
            dispatch(getSuccessAction(data));
          }
        });
    },
    [dispatch]
  );

  return {
    execute,
  };
};
